/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtraUser
 */
export interface ExtraUser {
    /**
     * 
     * @type {string}
     * @memberof ExtraUser
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExtraUser
     */
    id?: string;
}

export function ExtraUserFromJSON(json: any): ExtraUser {
    return ExtraUserFromJSONTyped(json, false);
}

export function ExtraUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtraUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function ExtraUserToJSON(value?: ExtraUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}


